import React, { useState, useEffect, useRef } from "react";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";

import OrderStatistics from "./components/OrderStatistics";
import BookingBar from "./components/bookingbar";
import Confirmation from "../vendor/components/vendorview/confimation";
import ConfirmationModal from "../services/components/confirmation";

const Dashboard = () => {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  // recent Vendor 1
  // Exoprt Button

  const [cusLength, setCusLength] = useState();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${baseUrl}/dashboard/customerLength`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setCusLength(data.message.registeredUserLength);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  });

  const [venLength, setvenLength] = useState();

  useEffect(() => {
    fetch(`${baseUrl}/dashboard/vendorLength`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // console.log(data.message.registeredVendorLength);
        setvenLength(data.message.registeredVendorLength);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  });

  const [lisLength, setLisLength] = useState();

  useEffect(() => {
    fetch(`${baseUrl}/dashboard/listingsCount`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setLisLength(data.message.listingsCount);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  });

  const [bookLength, setBookLength] = useState();

  useEffect(() => {
    fetch(`${baseUrl}/dashboard/bookingCount`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // console.log(data.message.registeredVendorLength);
        setBookLength(data.result.count);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  });







  // const closePopup = () => {

  //     // setConformBooking(false)
  //     document.body.classList.remove('popup-open');
  // };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  // Recent Listing start

  const dropdownRef1 = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const headers1 = [
    "Service Id",
    "Vendor Name",
    "Service Details",
    "Category",
    "Created Date",
    "Status",
    "Action",
  ];

  const headers12 = [
    "Customer Name",
    "Email Address",
    "Mobile Number",
    "Total Booking",
    "Status",
    "Actions",
  ];
  // Recent listing end

  // Recent Leading Start




  const serviceheaders = [
    "Service ID",
    "Service Name",
    "Category",
    "Vendor Name",
    "Basic Fare",
    "Status",
    "Action",
  ];


  // recent vendor

  const headers = [

    "Vendor Name",
    "Company Name",
    "Category",
    "Email",
    "Contact Person",
    "Zone",
    "Status",
    "Action",

  ];

  const [recentVendor, setRecentVendor] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [refreshDataTrigger, setRefreshDataTrigger] = useState(false);


  useEffect(() => {
    fetch(`${baseUrl}/vendoradmin/vendordetails`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const sortedVendors = data.message.vendorCollectionData.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });
        setRecentVendor(sortedVendors);
        console.log(sortedVendors, "jhjhggh")
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, [refreshDataTrigger]);

  const handleStatusToggle = (VendorId, currentStatus) => {
    const updatedStatus = currentStatus === 'active' ? 'inactive' : 'active';

    setSelectedVendorId(VendorId);
    setNewStatus(updatedStatus);
    setIsModalOpen(true);
  };

  const confirmStatusChange = () => {
    fetch(`${baseUrl}/vendoradmin/updateStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        vendorId: selectedVendorId,
        status: newStatus,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setRefreshDataTrigger(!refreshDataTrigger);
          setIsModalOpen(false);
        } else {
          setIsModalOpen(false);
          setRefreshDataTrigger(!refreshDataTrigger);

          console.error("updated status");
        }
      })
      .catch((error) => {
        console.error("There was an error updating the status:", error);
        setIsModalOpen(false);
      });
  };


  const cancelStatusChange = () => {
    setIsModalOpen(false);
  };


  
  





  const [data1, setData1] = useState([]);


  useEffect(() => {
    fetch(`${baseUrl}/services/allservices`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setData1(data.message.listingsData);
        console.log(data.message.listingsData);
      })
      .catch((error) => {

        console.log(error)
      });
  }, [baseUrl]);



  const filteredData = data1
    .map((item) => {
      const filteredServices = item.serviceDetails.filter((service) => {
        const subId = service.subId || "";
        const serviceName = service.serviceName || "";
        return subId || serviceName;
      });

      if (filteredServices.length > 0) {
        return {
          ...item,
          serviceDetails: filteredServices.slice(0, 3),
        };
      }
      return null;
    })
    .filter((item) => item !== null);

  const [showConfirmation1, setShowConfirmation1] = useState(false);
  const [customerToUpdate1, setCustomerToUpdate1] = useState(null);
  const [statusToUpdate1, setStatusToUpdate1] = useState(null);

  useEffect(() => {
    fetch(`${baseUrl}/customeradmin/customerdetails`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.message.customersData, "customersData");
        setData(data.message.customersData);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, []);

  const handleStatusToggle1 = (customer, currentStatus) => {
    setCustomerToUpdate1(customer);
    setStatusToUpdate1(currentStatus === "active" ? "inactive" : "active");
    setShowConfirmation1(true);
  };

  const confirmStatusChange1 = async () => {
    if (customerToUpdate1 && statusToUpdate1) {
      try {
        const response = await fetch(`${baseUrl}/customeradmin/reset-user-status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: customerToUpdate1.email,
            status: statusToUpdate1,
          }),
        });
        const result = await response.json();
        if (result) {
          setData((prevData) =>
            prevData.map((customer) =>
              customer.customerId === customerToUpdate1.customerId
                ? { ...customer, status: statusToUpdate1 }
                : customer
            )
          );
          alert(`Customer status updated to ${statusToUpdate1}`);
        } else {
          alert("Error updating status");
        }
      } catch (error) {
        console.error("Error changing status:", error);
        alert("Error changing status");
      }
    }
    setShowConfirmation1(false);
  };




  // 

  const [showModal, setShowModal] = useState(false);
  const [currentService, setCurrentService] = useState(null);

  const [serviceToUpdate1, setServiceToUpdate1] = useState(null);



  const handleStatusChange12 = (subId, currentStatus) => {
    setServiceToUpdate1(subId)
    setCurrentService({ subId, currentStatus });
    setShowModal(true);
  };

  const confirmStatusChange12 = async () => {
    const { subId, servicestatus } = currentService;
    const newStatus = servicestatus === "active" 
      ? "active" 
      : servicestatus === "active" 
      ? "active" 
      : servicestatus === "blocked" 
      ? "blocked"
      : "inactive"; 
  
    try {
      const response = await fetch(`${baseUrl}/services/serviceconfirmation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subId: String(subId),
          servicestatus: newStatus,
        }),
      });
  
      const result = await response.json();
  
      if (result.success) {
        window.location.reload(); 

        setData((prevData) =>
          prevData.map((item) => ({
            ...item,
            serviceDetails: item.serviceDetails.map((service) =>
              service.subId === subId
                ? { ...service, servicestatus: newStatus }
                : service
            ),
          }))
          
        );
      } else {
        alert(result.message || "Failed to update service status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Error updating status. Please try again.");
    } finally {
      setShowModal(false);
    }
  };
  
  const getNextStatus = (currentStatus) => {
    switch (currentStatus) {
        case "active":
            return "active";
        case "inactive":
            return "inactive"; 
        case "blocked":
            return "blocked";
        default:
            return "inactive"; 
    }
};

  const cancelStatusChange12 = () => {
    setShowModal(false);
  };

  return (
    <>
      < div className="w-full min-h-[75vh] h-auto rounded-2xl lg:p-0">
        <div className="md:px-10 px-5 w-full mt-20 lg:mt-0">
          <div className="lg:mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-6 justify-between">
            <Link to="/admin/customer">
              <div className="w-[280px] lg:w-[230px]  h-[115px] mt-5  lg:mt-0 px-2 lg:px-6 pt-3 drop-shadow-lg bg-white rounded-[15px] flex justify-between">
                <div className="mt-5 xl:mt-0">
                  <p className="text-[#252C58] font-[600px] xl:text-[38px] text-[24px]">
                    {cusLength}

                  </p>
                  <p className="text-[#252C58] text-[16px] font-[400]">
                    Customers
                  </p>
                </div>
                <div className="">
                  <svg
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      opacity="0.5"
                      cx="21"
                      cy="21"
                      r="21"
                      fill="#E6EAF5"
                    />
                    <mask
                      id="mask0_1337_5573"
                      maskUnits="userSpaceOnUse"
                      x="7"
                      y="7"
                      width="28"
                      height="28"
                    >
                      <rect
                        x="7"
                        y="7"
                        width="28"
                        height="28"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_1337_5573)">
                      <path
                        d="M13.8247 26.9507C14.8163 26.1923 15.9247 25.5944 17.1497 25.1569C18.3747 24.7194 19.658 24.5007 20.9997 24.5007C22.3413 24.5007 23.6247 24.7194 24.8497 25.1569C26.0747 25.5944 27.183 26.1923 28.1747 26.9507C28.8552 26.1534 29.3851 25.2493 29.7643 24.2382C30.1434 23.227 30.333 22.1479 30.333 21.0007C30.333 18.4145 29.424 16.2125 27.6059 14.3944C25.7879 12.5763 23.5858 11.6673 20.9997 11.6673C18.4136 11.6673 16.2115 12.5763 14.3934 14.3944C12.5754 16.2125 11.6663 18.4145 11.6663 21.0007C11.6663 22.1479 11.8559 23.227 12.2351 24.2382C12.6143 25.2493 13.1441 26.1534 13.8247 26.9507ZM20.9997 22.1673C19.8525 22.1673 18.8851 21.7736 18.0976 20.9861C17.3101 20.1986 16.9163 19.2312 16.9163 18.084C16.9163 16.9368 17.3101 15.9694 18.0976 15.1819C18.8851 14.3944 19.8525 14.0007 20.9997 14.0007C22.1469 14.0007 23.1143 14.3944 23.9018 15.1819C24.6893 15.9694 25.083 16.9368 25.083 18.084C25.083 19.2312 24.6893 20.1986 23.9018 20.9861C23.1143 21.7736 22.1469 22.1673 20.9997 22.1673ZM20.9997 32.6673C19.3858 32.6673 17.8691 32.3611 16.4497 31.7486C15.0302 31.1361 13.7955 30.3048 12.7455 29.2548C11.6955 28.2048 10.8643 26.9701 10.2518 25.5507C9.63926 24.1312 9.33301 22.6145 9.33301 21.0007C9.33301 19.3868 9.63926 17.8701 10.2518 16.4507C10.8643 15.0312 11.6955 13.7965 12.7455 12.7465C13.7955 11.6965 15.0302 10.8652 16.4497 10.2527C17.8691 9.64023 19.3858 9.33398 20.9997 9.33398C22.6136 9.33398 24.1302 9.64023 25.5497 10.2527C26.9691 10.8652 28.2038 11.6965 29.2538 12.7465C30.3038 13.7965 31.1351 15.0312 31.7476 16.4507C32.3601 17.8701 32.6663 19.3868 32.6663 21.0007C32.6663 22.6145 32.3601 24.1312 31.7476 25.5507C31.1351 26.9701 30.3038 28.2048 29.2538 29.2548C28.2038 30.3048 26.9691 31.1361 25.5497 31.7486C24.1302 32.3611 22.6136 32.6673 20.9997 32.6673ZM20.9997 30.334C22.0302 30.334 23.0025 30.1833 23.9163 29.8819C24.8302 29.5805 25.6663 29.1479 26.4247 28.584C25.6663 28.0201 24.8302 27.5875 23.9163 27.2861C23.0025 26.9847 22.0302 26.834 20.9997 26.834C19.9691 26.834 18.9969 26.9847 18.083 27.2861C17.1691 27.5875 16.333 28.0201 15.5747 28.584C16.333 29.1479 17.1691 29.5805 18.083 29.8819C18.9969 30.1833 19.9691 30.334 20.9997 30.334ZM20.9997 19.834C21.5052 19.834 21.9233 19.6687 22.2538 19.3382C22.5844 19.0076 22.7497 18.5895 22.7497 18.084C22.7497 17.5784 22.5844 17.1604 22.2538 16.8298C21.9233 16.4993 21.5052 16.334 20.9997 16.334C20.4941 16.334 20.0761 16.4993 19.7455 16.8298C19.415 17.1604 19.2497 17.5784 19.2497 18.084C19.2497 18.5895 19.415 19.0076 19.7455 19.3382C20.0761 19.6687 20.4941 19.834 20.9997 19.834Z"
                        fill="#27648B"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </Link>

            <Link to="/admin/vendor">
              <div className="xl:ml-6 w-[280px]  lg:w-[230px]   h-[115px] mt-5 lg:mt-0 px-2 lg:px-6 pt-3 drop-shadow-lg bg-white rounded-[15px] flex justify-between">
                <div className="mt-5 xl:mt-0">
                  <p className="text-[#252C58] xl:text-[38px] text-[24px] font-[600px] ">
                    {venLength}
                  </p>
                  <p className="text-[#252C58] text-[16px] font-[400]">
                    Vendors
                  </p>
                </div>
                <div className="bg-[#E6EAF5] rounded-[50%] h-[42px] w-[42px] flex  items-center justify-center">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1337_5580"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                    >
                      <rect width="28" height="28" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1337_5580)">
                      <path
                        d="M13.9997 18.084C14.6413 18.084 15.1906 17.8555 15.6476 17.3986C16.1045 16.9416 16.333 16.3923 16.333 15.7507C16.333 15.109 16.1045 14.5597 15.6476 14.1027C15.1906 13.6458 14.6413 13.4173 13.9997 13.4173C13.358 13.4173 12.8087 13.6458 12.3518 14.1027C11.8948 14.5597 11.6663 15.109 11.6663 15.7507C11.6663 16.3923 11.8948 16.9416 12.3518 17.3986C12.8087 17.8555 13.358 18.084 13.9997 18.084ZM4.66634 24.5007C4.02467 24.5007 3.47537 24.2722 3.01842 23.8152C2.56148 23.3583 2.33301 22.809 2.33301 22.1673V9.33398C2.33301 8.69232 2.56148 8.14301 3.01842 7.68607C3.47537 7.22912 4.02467 7.00065 4.66634 7.00065H9.33301V4.66732C9.33301 4.02565 9.56148 3.47635 10.0184 3.0194C10.4754 2.56246 11.0247 2.33398 11.6663 2.33398H16.333C16.9747 2.33398 17.524 2.56246 17.9809 3.0194C18.4379 3.47635 18.6663 4.02565 18.6663 4.66732V7.00065H23.333C23.9747 7.00065 24.524 7.22912 24.9809 7.68607C25.4379 8.14301 25.6663 8.69232 25.6663 9.33398V22.1673C25.6663 22.809 25.4379 23.3583 24.9809 23.8152C24.524 24.2722 23.9747 24.5007 23.333 24.5007H4.66634ZM4.66634 22.1673H23.333V9.33398H4.66634V22.1673ZM11.6663 7.00065H16.333V4.66732H11.6663V7.00065Z"
                        fill="#27648B"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </Link>

            <Link to="/admin/services">
              <div className="xl:ml-6 w-[280px] lg:w-[230px]   h-[115px] mt-5 lg:mt-0 px-2 lg:px-6 pt-3 drop-shadow-lg bg-white rounded-[15px] flex justify-between">
                <div className="mt-5 xl:mt-0">
                  <p className="text-[#252C58] xl:text-[38px] text-[24px] font-[600px] ">
                    {lisLength}
                  </p>
                  <p className="text-[#252C58] text-[16px] font-[400]">
                    Services                  </p>
                </div>
                <div className="bg-[#E6EAF5] rounded-[50%] h-[42px] w-[42px] flex justify-center items-center">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1337_5583"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                    >
                      <rect width="28" height="28" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1337_5583)">
                      <path
                        d="M16.333 8.16732V5.83398H25.6663V8.16732H16.333ZM16.333 12.834V10.5007H25.6663V12.834H16.333ZM16.333 17.5007V15.1673H25.6663V17.5007H16.333ZM9.33301 16.334C8.36079 16.334 7.5344 15.9937 6.85384 15.3132C6.17329 14.6326 5.83301 13.8062 5.83301 12.834C5.83301 11.8618 6.17329 11.0354 6.85384 10.3548C7.5344 9.67426 8.36079 9.33398 9.33301 9.33398C10.3052 9.33398 11.1316 9.67426 11.8122 10.3548C12.4927 11.0354 12.833 11.8618 12.833 12.834C12.833 13.8062 12.4927 14.6326 11.8122 15.3132C11.1316 15.9937 10.3052 16.334 9.33301 16.334ZM2.33301 23.334V21.1173C2.33301 20.709 2.43023 20.3201 2.62467 19.9507C2.81912 19.5812 3.09134 19.2895 3.44134 19.0757C4.31634 18.5507 5.24481 18.1569 6.22676 17.8944C7.2087 17.6319 8.24412 17.5007 9.33301 17.5007C10.4219 17.5007 11.4573 17.6319 12.4393 17.8944C13.4212 18.1569 14.3497 18.5507 15.2247 19.0757C15.5747 19.2895 15.8469 19.5812 16.0413 19.9507C16.2358 20.3201 16.333 20.709 16.333 21.1173V23.334H2.33301ZM4.84134 21.0007H13.8247C13.1441 20.6118 12.4247 20.3201 11.6663 20.1257C10.908 19.9312 10.1302 19.834 9.33301 19.834C8.53579 19.834 7.75801 19.9312 6.99967 20.1257C6.24134 20.3201 5.5219 20.6118 4.84134 21.0007ZM9.33301 14.0007C9.66356 14.0007 9.94065 13.8888 10.1643 13.6652C10.3879 13.4416 10.4997 13.1645 10.4997 12.834C10.4997 12.5034 10.3879 12.2263 10.1643 12.0027C9.94065 11.7791 9.66356 11.6673 9.33301 11.6673C9.00245 11.6673 8.72537 11.7791 8.50176 12.0027C8.27815 12.2263 8.16634 12.5034 8.16634 12.834C8.16634 13.1645 8.27815 13.4416 8.50176 13.6652C8.72537 13.8888 9.00245 14.0007 9.33301 14.0007Z"
                        fill="#27648B"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </Link>

            <Link to="/admin/booking">
              <div className="xl:ml-6 w-[280px] lg:w-[230px]   h-[115px] mt-5 lg:mt-0 px-2 lg:px-6 pt-3 drop-shadow-lg bg-white rounded-[15px] flex justify-between">
                <div className="mt-5 xl:mt-0">
                  <p className="text-[#252C58] xl:text-[38px] text-[24px] font-[600px] ">
                    {bookLength}
                  </p>
                  <p className="text-[#252C58] text-[16px] font-[400]">
                    Total Orders                  </p>
                </div>
                <div className="bg-[#E6EAF5] rounded-[50%] h-[42px] w-[42px] flex justify-center items-center">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1453_26064"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                    >
                      <rect width="28" height="28" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1453_26064)">
                      <path
                        d="M4.66634 22.1667H9.33301V12.8333H4.66634V22.1667ZM11.6663 22.1667H16.333V5.83333H11.6663V22.1667ZM18.6663 22.1667H23.333V15.1667H18.6663V22.1667ZM2.33301 24.5V10.5H9.33301V3.5H18.6663V12.8333H25.6663V24.5H2.33301Z"
                        fill="#27648B"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </Link>
          </div>
          <div className="flex flex-col md:flex-row gap-4 mt-10">
            <BookingBar />
            <OrderStatistics />
          </div>

          <div className="mt-5 lg:mt-0">
            <div className="xl:w-full lg:w-[700px] flex justify-between items-center lg:h-[100px]">
              <p className="text-[20px] text-[#27648B] font-semibold">
                Recent Vendors
              </p>
              <Link to={"/admin/vendor"}>
                <button className="border-0 h-[30px] font-semibold rounded-[4px] text-[#27648B]">
                  View All
                </button>
              </Link>
            </div>

            <div className="w-full xl:w-full lg:w-[700px] overflow-x-auto mb-10">
              <div className="max-w-full rounded-sm border-l-stroke border-r-stroke bg-white shadow-default dark:border-t-strokedark dark:bg-boxdark">
                <table className="w-full table-auto">
                  <thead>
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="border-t-[2px] border-b-[2px] py-5 bg-[#F8F9FA] text-center text-[14px] font-semibold text-[#111927]"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>

                    {recentVendor?.slice(0, 3).map((item, index) => (
                      <tr key={index} className="border-gray-400 border-b-[1px] ">
                        <td className="text-center  font-semibold text-[#2F3746] py-5 ">
                          <p>{item.FullName}</p>
                        </td>
                        <td className="text-center text-[#8C90A6] py-5">
                          <p>{item.companyName}</p>
                        </td>
                        <td className="text-center text-[#8C90A6] py-5">
                          <p>{item.category.categoryTitle}</p>
                        </td>
                        <td className="text-center text-[#8C90A6] py-5">
                          <p>{item.email}</p>
                        </td>
                        <td className="text-center text-[#8C90A6] py-5">
                          <p>{item.number}</p>
                        </td>
                        <td className="text-center text-[#8C90A6] py-5">
                          <p>{item.zone?.zoneId}</p>
                        </td>
                        <td className="text-center py-5">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="hidden"
                              checked={item.status === 'active'}
                              onChange={() => handleStatusToggle(item.VendorId, item.status)}
                            />
                            <span
                              className={`relative inline-block w-10 h-6 transition-all duration-200 ease-in-out rounded-full ${item.status === 'active' ? 'bg-[#2A668D]' : 'bg-gray-400'}`}
                            >
                              <span
                                className={`absolute top-0 left-0 w-4 h-4 bg-white ml-1 mt-1 rounded-full transition-transform duration-200 ease-in-out ${item.status === 'active' ? 'translate-x-4' : ''}`}
                              ></span>
                            </span>
                          </label>
                        </td>
                        <Link to={`/admin/vendor/vendorveiw?id=${item.VendorId}`}>
                          <td className="text-center text-[#8C90A6] py-5">
                            <div className="flex justify-center ml-[10px] cursor-pointer">
                              <svg
                                width="20"
                                height="17"
                                viewBox="0 0 20 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M13.1619 8.05262C13.1619 9.79862 11.7459 11.2136 9.99987 11.2136C8.25387 11.2136 6.83887 9.79862 6.83887 8.05262C6.83887 6.30562 8.25387 4.89062 9.99987 4.89062C11.7459 4.89062 13.1619 6.30562 13.1619 8.05262Z"
                                  stroke="#B2B2B2"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.998 15.354C13.806 15.354 17.289 12.616 19.25 8.052C17.289 3.488 13.806 0.75 9.998 0.75H10.002C6.194 0.75 2.711 3.488 0.75 8.052C2.711 12.616 6.194 15.354 10.002 15.354H9.998Z"
                                  stroke="#B2B2B2"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </td>
                        </Link>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <Confirmation
              isOpen={isModalOpen}
              message={`Are you sure you want to change this vendor's status to ${newStatus}?`}
              onConfirm={confirmStatusChange}
              onCancel={cancelStatusChange}
            />
          </div>


          <div className="xl:w-full lg:w-[700px]">
            <div className="flex justify-between items-center lg:h-[100px]">
              <p className="text-[20px] text-[#27648B] font-[600]">
                Recent Customer
              </p>
              <Link to={"/admin/customer"}>
                {" "}
                <button className="border-0 h-[30px] font-medium rounded-[4px] text-[#27648B]">
                  View All
                </button>
              </Link>
            </div>
            <div className="max-w-full xl:w-full lg:w-[700px] overflow-x-auto mb-10">
              <div className="max-w-full rounded-sm border-l-stroke border-r-stroke bg-white shadow-default dark:border-t-strokedark dark:bg-boxdark overflow-x-auto">
                <table className="w-full table-auto">
                  <thead>
                    <tr>
                      {headers12.map((header, index) => (
                        <th
                          key={index}
                          className="border-t-[2px] border-b-[2px] py-5 xl:px-4 px-10 bg-[#F8F9FA] text-[14px] font-semibold text-[#2F3746]"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      Array.isArray(data) &&
                      data.slice(0, 5).map((item, index) => (
                        <tr
                          key={index}
                          className="border-gray-400 border-b-[1px]"
                        >
                          <td className="text-center text-[#8C90A6] py-5">
                            <p>{item.FullName} rafiya</p>
                          </td>
                          <td className="text-center text-[#8C90A6] py-5">
                            <p>{item.email}rafiya@gmail.com</p>
                          </td>
                          <td className="text-center text-[#8C90A6] py-5">
                            <p>{item.number}1223</p>
                          </td>
                          <td className="text-center text-[#8C90A6] py-5">
                            <p>{item.totalBooking}12



                            </p>
                          </td>
                          <td className="text-center text-[#8C90A6] py-5">
                            <label className="inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                className="hidden"
                                checked={item.status === "active"}
                                onChange={() =>
                                  handleStatusToggle1(item, item.status)
                                }
                              />
                              <span
                                className={`relative inline-block w-10 h-6 transition-all duration-200 ease-in-out rounded-full ${item.status === "active" ? "bg-[#2A668D]" : "bg-gray-400"
                                  }`}
                              >
                                <span
                                  className={`absolute top-0 left-0 w-4 h-4 bg-white ml-1 mt-1 rounded-full transition-transform duration-200 ease-in-out ${item.status === "active" ? "translate-x-4" : ""
                                    }`}
                                ></span>
                              </span>
                            </label>
                          </td>
                          <Link to={`/admin/customer/viewcustomer?id=${item.email}`}>
                            <td className="text-center text-[#8C90A6] py-5 ">
                              <div className="flex justify-center ml-[10px] cursor-pointer">
                                <svg
                                  width="20"
                                  height="17"
                                  viewBox="0 0 20 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.1619 8.05262C13.1619 9.79862 11.7459 11.2136 9.99987 11.2136C8.25387 11.2136 6.83887 9.79862 6.83887 8.05262C6.83887 6.30562 8.25387 4.89062 9.99987 4.89062C11.7459 4.89062 13.1619 6.30562 13.1619 8.05262Z"
                                    stroke="#B2B2B2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.998 15.354C13.806 15.354 17.289 12.616 19.25 8.052C17.289 3.488 13.806 0.75 9.998 0.75H10.002C6.194 0.75 2.711 3.488 0.75 8.052C2.711 12.616 6.194 15.354 10.002 15.354H9.998Z"
                                    stroke="#B2B2B2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            </td></Link>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {showConfirmation1 && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white p-6 rounded-md shadow-lg w-1/3">
                    <p className="text-lg text-center mb-4">
                      Are you sure you want to {statusToUpdate1} this customer?
                    </p>
                    <div className="flex justify-around">
                      <button
                        onClick={confirmStatusChange1}
                        className="bg-green-500 text-white px-4 py-2 rounded-md"
                      >
                        Confirm
                      </button>
                      <button
                        onClick={() => setShowConfirmation1(false)}
                        className="bg-red-500 text-white px-4 py-2 rounded-md"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="xl:w-full lg:w-[700px]">
            <div className="flex justify-between items-center lg:h-[100px]">
              <p className="text-[20px] text-[#27648B] font-[600]">
                Recent Services
              </p>
              <Link to={"/admin/services"}>
                <button className="border-0 h-[30px] font-medium rounded-[4px] text-[#27648B]">
                  View All
                </button>
              </Link>
            </div>
            <div className="max-w-full xl:w-full lg:w-[700px] overflow-x-auto mb-10">
              <div className="max-w-full rounded-sm border-l-stroke border-r-stroke bg-white shadow-default dark:border-t-strokedark dark:bg-boxdark overflow-x-auto">
                <table className="w-full table-auto">
                  <thead>
                    <tr>
                      {serviceheaders.map((header, index) => (
                        <th
                          key={index}
                          className="border-t-[2px] border-b-[2px] py-5 xl:px-4 px-10 bg-[#F8F9FA] text-[14px] font-semibold text-[#2F3746]"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.slice(0, 5).map((item, index) => (
                      <React.Fragment key={index}>
                        {item.serviceDetails.slice(0, 5).map((service, serviceIndex) => (
                          <tr key={serviceIndex} className="border-gray-400 border-b-[1px]">
                            <td className="text-center font-semibold text-[#2F3746] py-5">
                              {service.subId || "N/A"}
                            </td>
                            <td className="text-center text-[#8C90A6] py-5">
                              {service.serviceName || "N/A"}
                            </td>
                            <td className="text-center text-[#8C90A6] py-5">
                              {item.categoryTitle || "N/A"}
                            </td>
                            <td className="text-center text-[#8C90A6] py-5">
                              {item.companyName || "N/A"}
                            </td>
                            <td className="text-center text-[#8C90A6] py-5">
                              {service.price || "N/A"}
                            </td>
                            <td className="text-center text-[#8C90A6] py-5">
                              <label className="inline-flex items-center cursor-pointer">
                                <select
                                  className="p-2 border rounded-md"
                                  value={service.servicestatus}
                                  onChange={(e) => handleStatusChange12(service.subId, e.target.value)}
                                >
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                  <option value="blocked">Blocked</option>
                                  <option value="unblocked">Unblocked</option>
                                </select>
                              </label>
                            </td>

                            <Link to={`/admin/vendor/vendorveiw?id=${item.email}`}>
                              <td className="text-center text-[#8C90A6] py-5">
                                <div className="flex justify-start ml-[10px] cursor-pointer">
                                  <svg
                                    width="20"
                                    height="17"
                                    viewBox="0 0 20 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M13.1619 8.05262C13.1619 9.79862 11.7459 11.2136 9.99987 11.2136C8.25387 11.2136 6.83887 9.79862 6.83887 8.05262C6.83887 6.30562 8.25387 4.89062 9.99987 4.89062C11.7459 4.89062 13.1619 6.30562 13.1619 8.05262Z"
                                      stroke="#B2B2B2"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M9.998 15.354C13.806 15.354 17.289 12.616 19.25 8.052C17.289 3.488 13.806 0.75 9.998 0.75H10.002C6.194 0.75 2.711 3.488 0.75 8.052C2.711 12.616 6.194 15.354 10.002 15.354H9.998Z"
                                      stroke="#B2B2B2"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </td>
                            </Link>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
              {showModal && (
                <ConfirmationModal
                message={`Are you sure you want to change the service status to ${getNextStatus(currentService?.currentStatus)}?`}
                onConfirm={confirmStatusChange12}
                  onCancel={cancelStatusChange12}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
